import Vue from 'vue';
import VueRouter from 'vue-router';
import { refreshAccessToken } from '@/libs/axios';
import { getAccessToken } from '@/services/SessionService';
import post from '@/router/routes/post';
import contacts from '@/router/routes/contacts';
import replies from '@/router/routes/replies';

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    ...post,
    ...contacts,
    ...replies,
    {
      path: '/',
      name: 'dashboard',
      component: () => import('@/views/Dashboard.vue'),
      meta: {
        protected: true,
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/mdm',
      name: 'mdm',
      component: () => import('@/views/mdm/MdmSetup.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, from, next) => {
  const token = getAccessToken();
  const loggedIn = !!token;

  // Authed routes that do not allow unauthed users
  if (loggedIn && to.meta.redirectAuthed) {
    next({
      path: '/dashboard',
    });
    return;
  }

  if (loggedIn || !to.meta.protected) {
    next();
    return;
  }

  refreshAccessToken().then(() => {
    next();
  }).catch(() => {
    next({
      path: '/login',
      query: {
        redirect: to.fullPath,
      },
    });
  });
});

export default router
